import { Component, OnInit } from '@angular/core';
import { scaleIn400ms } from '../../../../../../../@vex/animations/scale-in.animation';
import { fadeInRight400ms } from '../../../../../../../@vex/animations/fade-in-right.animation';
import { stagger40ms } from '../../../../../../../@vex/animations/stagger.animation';
import { fadeInUp400ms } from '../../../../../../../@vex/animations/fade-in-up.animation';
import { scaleFadeIn400ms } from '../../../../../../../@vex/animations/scale-fade-in.animation';
import { EquipmentService } from '../../equipment.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CrudModeEnum } from '../../../../../../core/base/enum/crud-mode.enum';
import { EquipmentCreateUpdateDeleteComponent } from '../../equipment-create-update-delete/equipment-create-update-delete.component';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { FeiColumn } from '../../../../../../core/base/interfaces/fei-column.interface';
import icAdd from '@iconify/icons-ic/twotone-add';
import { EquipmentLocationsCreateUpdateDeleteComponent } from './equipment-locations-create-update-delete/equipment-locations-create-update-delete.component';
import { EquipmentActivityCreateUpdateDeleteComponent } from './equipment-activity-create-update-delete/equipment-activity-create-update-delete.component';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';
import { EquipmentModel } from '../../../../../../core/models/equipment.model';
import { HistoriqueEvent } from '../../../../../../core/base/components/history/history.component';
import { EquipmentMetrikStatusComponent } from './equipment-metrik/equipment-metrik-status.component';
import { convertToHistoriqueEvents, getCurrentAndNextStatus } from '../../../../../../core/utils/metrikStatus-utils';
import { BuildingArchiveDeleteComponent } from '../../../building/modals/building-archive-delete/building-archive-delete.component';
import { EquipmentArchiveDeleteComponent } from '../../modals/equipment-archive-delete/equipment-archive-delete.component';
import { BuildingMetrikStatusComponent } from '../../../building/building-details/building-details-resume/building-metrik-status/building-metrik-status.component';
import { BuildingModel } from '../../../../../../core/models/building.model';
import { DependenciesService } from '../../../../../../core/services/dependencies.service';
import { DefaultSupervisionMetrikTypeEnum } from '../../../../../../core/models/default-supervision.model';

@Component({
  selector: 'vex-equipment-details-resume',
  templateUrl: './equipment-details-resume.component.html',
  styleUrls: ['./equipment-details-resume.component.scss'],
  animations: [scaleIn400ms, fadeInRight400ms, stagger40ms, fadeInUp400ms, scaleFadeIn400ms],
})
export class EquipmentDetailsResumeComponent implements OnInit {
  icAdd = icAdd;
  ENUM_PERMISSIONS = ENUM_PERMISSIONS;
  metrikTypeEnum = DefaultSupervisionMetrikTypeEnum;
  equipment: EquipmentModel;

  dataSourceAmortization: MatTableDataSource<any>;
  displayedColumnsAmortization = [];
  feisColumnsAmortization: Array<FeiColumn> = [
    { label: 'Date de début', column: 'startDate', type: 'date' },
    { label: 'Date de fin', column: 'endDate', type: 'date' },
    { label: 'Nombre de jours', column: 'nbOfDay' },
    { label: "Montant de l'amortissement", column: 'amortizationAmount' },
    { label: "Cumul de l'amortissement", column: 'accumulatedAmount' },
    { label: "Valeur nette de l'équipement", column: 'netValue' },
  ];

  listOfLocationId: string[] = [];

  dataSourceLocationHistory: MatTableDataSource<any>;
  displayedColumnsLocationHistory = [];
  feisColumnsLocationHistory: Array<FeiColumn> = [
    { label: 'Identifiant technique', column: 'technicalIdentifier' },
    { label: 'Bâtiment', column: 'building', propertyDisplay: 'building.label' },
    { label: 'Salle', column: 'room', propertyDisplay: 'room.label' },
    { label: 'Etage', column: 'stage', propertyDisplay: 'room.stage.label' },
    { label: 'Surface Totale', column: 'surface', type: 'custom', status: 'enabled' },
    { label: 'Nombre de lits', column: 'nbOfBeds', propertyDisplay: 'room.nbOfBed' },
    { label: "Date d'ajout", column: 'addedAt', type: 'date' },
    { label: 'Date de suppression', column: 'deletedAt', type: 'date' },
  ];

  feisColumnsActivity: Array<FeiColumn> = [
    { label: 'Bâtiment', column: 'building', propertyDisplay: 'building.technicalIdentifier' },
    { label: 'Activité', column: 'activity', propertyDisplay: 'activity.label' },
    { label: 'Pourcentage', column: 'percent' },
    { label: '', column: 'actions' },
  ];
  displayedColumnsActivity = [];
  dataSourceActivity: MatTableDataSource<any>;
  displayPercentWarning = false;
  displayLocation = false;
  displayHistoryLocation = false;
  isEditable = true;
  showMotif = false;

  historiqueData: HistoriqueEvent[] = [];

  constructor(
    public service: EquipmentService,
    private dialog: MatDialog,
    private dependencyService: DependenciesService<EquipmentModel>,
  ) {
    this.displayedColumnsAmortization = this.feisColumnsAmortization.map(x => x.column);
    this.displayedColumnsLocationHistory = this.feisColumnsLocationHistory.map(x => x.column);
    this.displayedColumnsActivity = this.feisColumnsActivity.map(x => x.column);
  }

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    this.service.entity$.subscribe((equipment: EquipmentModel) => {
      this.equipment = equipment;
      this.dataSourceAmortization = new MatTableDataSource<any>(equipment?.amortization);
      this.dataSourceLocationHistory = new MatTableDataSource<any>(equipment?.locationHistory);
      const activities = (equipment?.activities || []).filter(a => !a.activity?.isArchive && !a.activity?.isDelete);
      this.dataSourceActivity = new MatTableDataSource<any>(activities);
      this.displayPercentWarning = activities.length > 0 ? activities.reduce((p, c) => p + c.percent, 0) !== 100 : true;
      this.displayHistoryLocation = !equipment?.genericEquipment?.isFixed;
      this.displayLocation = !equipment?.location;
      this.historiqueData = convertToHistoriqueEvents(getCurrentAndNextStatus(equipment.metrikStatus));
      this.showMotif = this.checkEndServiceDate(equipment);
    });
  }

  async updateItem() {
    this.dialog.open(EquipmentCreateUpdateDeleteComponent, {
      data: {
        defaults: await this.service.entity,
        mode: CrudModeEnum.Update,
      },
    });
  }

  async addLocation() {
    this.dialog
      .open(EquipmentLocationsCreateUpdateDeleteComponent, {
        data: {
          listOfLocationId: this.listOfLocationId,
          defaults: await this.service.entity,
          mode: CrudModeEnum.Create,
        },
        width: '600px', // Elargir la modale pour voir le libellé complet du bâtiment
        maxWidth: '90vw', // Responsive: max 90% de la largeur de l'écran
      })
      .afterClosed()
      .subscribe(location => {
        if (location) {
          this.initData();
        }
      });
  }

  async updateItemActivity($event: any) {
    const equipment = await this.service.entity;
    this.dialog
      .open(EquipmentActivityCreateUpdateDeleteComponent, {
        data: {
          mode: CrudModeEnum.Update,
          equipment,
          defaults: $event,
        },
      })
      .afterClosed()
      .subscribe(activity => {
        if (activity) {
          this.initData();
        }
      });
  }

  async deleteItemActivity($event: any) {
    const equipment = await this.service.entity;
    this.dialog
      .open(EquipmentActivityCreateUpdateDeleteComponent, {
        data: {
          mode: CrudModeEnum.Delete,
          defaults: $event,
          equipment,
          name: `${$event?.activity?.label}`,
        },
      })
      .afterClosed()
      .subscribe(activity => {
        if (activity) {
          this.initData();
        }
      });
  }

  async createActivity() {
    const equipment = await this.service.entity;
    this.dialog
      .open(EquipmentActivityCreateUpdateDeleteComponent, {
        data: {
          mode: CrudModeEnum.Create,
          equipment,
        },
      })
      .afterClosed()
      .subscribe(activity => {
        if (activity) {
          this.initData();
        }
      });
  }

  async setEndServiceDate() {
    const equipment = await this.service.entity;

    const dependencies = await this.dependencyService
      .setService(this.service)
      .setModuleName('équipement')
      .setModuleNameWithArticle('un équipement')
      .setModuleNameTitleWithArticle("de l'équipement")
      .check(equipment);

    if (dependencies.hasDependencies) {
      await this.dependencyService
        .setService(this.service)
        .setModuleName(equipment.reference)
        .setModuleNameWithArticle('un équipement')
        .setModuleNameTitleWithArticle("de l'équipement")
        .setActionType('end-service')
        .setIsStepByStep(true)
        .checkDependencies(equipment, (refresh: boolean) => {
          // Après le traitement des dépendances, ouvrir la modale de metrik
          this.openMetrikModal();
        });
    } else {
      // Pas de dépendances, ouvrir directement la modale de metrik
      this.openMetrikModal();
    }
  }

  private openMetrikModal() {
    this.service.entity.then(equipment => {
      this.dialog
        .open(EquipmentMetrikStatusComponent, {
          data: {
            equipment,
            mode: CrudModeEnum.Custom,
          },
          width: '620px',
        })
        .afterClosed()
        .subscribe((equipment: EquipmentModel) => {
          if (equipment) {
            this.initData();
          }
        });
    });
  }

  async createMetrikStatus() {
    const equipment = await this.service.entity;
    this.dialog
      .open(EquipmentMetrikStatusComponent, {
        data: {
          equipment,
          mode: CrudModeEnum.Create,
        },
        width: '620px',
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.initData();
        }
      });
  }

  displayMessage() {
    let message = '';
    if (this.displayPercentWarning) {
      message += 'Le pourcentage doit être égal à 100 %.';
    }
    if (this.displayLocation) {
      message += '\n Veuillez affecter au préalable un emplacement pour pouvoir ajouter une activité. ';
    }

    return message;
  }

  hideActionButtons() {
    const indexActivity = this.feisColumnsActivity.findIndex(x => x.column === 'actions');
    if (indexActivity !== -1) {
      this.feisColumnsActivity.splice(indexActivity, 1);
      this.displayedColumnsActivity = this.feisColumnsActivity.map(x => x.column);
    }
  }

  checkEndServiceDate(equipment: EquipmentModel) {
    // if (equipment.operationalStatus?.endServiceDate) {
    //     const today = this.normalizeDate(new Date());
    //     const endServiceDate = this.normalizeDate(new Date (equipment.operationalStatus?.endServiceDate));
    //     return endServiceDate && endServiceDate < today;
    // } else if (equipment.operationalStatus?.metrikStatus.reason) {
    //     return true;
    // }
    return false;
  }

  normalizeDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  /**
   * Vérifie si une metrik définitive existe dans l'historique des metriks
   * Une metrik définitive (isDefinitivelyOver) ne peut être créée qu'une seule fois et est irréversible
   */
  hasDefinitiveMetrik(equipment: EquipmentModel): boolean {
    if (!equipment?.metrikStatus || equipment.metrikStatus.length === 0) {
      return false;
    }
    return equipment.metrikStatus.some(metrik => metrik.isDefinitivelyOver === true);
  }
}
